import { useState, useEffect, useRef } from "react";
import { Box, Icon } from "@oneloop/jopijs";
import isAValidLink from "../../wysiwygUtils/isAValidLink";
import localStyles from "./styles.module.scss";

function PickerWithInput({
  placeholder,
  onSubmit,
  onCancel,
  ctaText = "Accept",
  styles,
  isLoading = false,
}) {
  const inputRef = useRef(null);
  const [link, setLink] = useState("");
  const [inputIsDirty, setInputIsDirty] = useState(false);

  const isValidLink = isAValidLink(link);
  const shouldShowErrorMessage = !isValidLink && inputIsDirty && link;

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [inputRef]);

  useEffect(() => {
    if (!link) {
      setInputIsDirty(false);
    }
  }, [link]);

  const handleChange = (event) => {
    const { value } = event.target;
    setLink(value);
  };

  const handleFocus = (event) => {
    event.target.select();
    if (!link) setInputIsDirty(false);
  };

  const handleBlur = () => {
    setInputIsDirty(true);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isValidLink) return;

    onSubmit(link);
  };

  return (
    <Box as="form" className={localStyles.form} onSubmit={handleSubmit}>
      <Box className={localStyles["input-and-buttons"]}>
        <Box
          __css={styles ?? {}}
          className={`${localStyles["input-wrapper"]} ${
            shouldShowErrorMessage ? localStyles["input-wrapper--error"] : ""
          }`}
        >
          <Box
            ref={inputRef}
            as="input"
            placeholder={placeholder}
            value={link}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            className={localStyles.input}
          />

          {shouldShowErrorMessage && (
            <Icon icon="icon-error" fontSize="16px" color="#a71601" />
          )}
        </Box>
        <Box className={localStyles["button-group"]}>
          <Box
            as="button"
            type="button"
            className={localStyles["cancel-button"]}
            onClick={onCancel}
          >
            Cancel
          </Box>
          <Box
            as="button"
            type="submit"
            className={localStyles["accept-button"]}
            disabled={!isValidLink || isLoading}
          >
            {ctaText}
          </Box>
        </Box>
      </Box>

      {shouldShowErrorMessage && (
        <Box className={localStyles["error-message"]}>Invalid link</Box>
      )}
    </Box>
  );
}

export default PickerWithInput;
